<template>
    <div v-if="loading" class="pt-3">
        <h3 class="text-muted text-center"><i class="fas fa-spinner fa-lg fa-spin align-middle"></i> Loading...</h3>
    </div>
    <div v-else-if="documents.length" class="table-responsive">
        <table class="table table-sm">
            <thead>
                <th>Claim Number</th>
                <th>PAN</th>
                <th>DOS</th>
                <th>Patient</th>
                <th>Client</th>
                <th>Provider</th>
                <th>Payer</th>
                <th>Description</th>                    
                <th class="text-right">Est. Reimb.</th>
                <th class="text-right">Balance</th>
                <th class="text-right">Days Overdue</th>
                <th></th>
            </thead>
            <tbody>
                <tr v-for="document in documents" :key="'overdue-claims-' + document.service_form_id">
                    <td><a :href="document.href" v-text="document.claim_number"></a></td>
                    <td><a :href="document.services_href" v-text="document.pan"></a></td>
                    <td><a :href="document.services_href" v-text="document.dos"></a></td>                    
                    <td><a :href="document.href" v-text="document.patient_name"></a></td>
                    <td :title="document.client_name">{{ document.client_name | truncate(25) }}</td>
                    <td :title="document.rendering_provider_name">{{ document.rendering_provider_name | truncate(25) }}</td>
                    <td :title="document.payer_name">{{ document.payer_name | truncate(25) }}</td>
                    <td :title="document.description">{{ document.description | truncate(25) }}</td>
                    <td class="text-right">{{ document.estimated_reimbursement | currency }}</td>
                    <td class="text-right">{{ document.balance | currency }}</td>
                    <td class="text-right">{{ document.days_overdue }}</td> 
                    <td class="text-right">
                        <button type="button" class="btn btn-link p-0" :title="title === 'active' ? 'Hide' : 'Active'" @click="changeState(document)">
                            <i v-if="title === 'active'" class="fas fa-eye-slash fa-lg"></i>
                            <i v-else class="fas fa-eye fa-lg"></i>
                        </button>                        
                    </td>            
                </tr>
            </tbody>
        </table>
    </div>
    <div v-else>
        <h2 class="text-muted text-center mt-3">No {{ title }} overdue payments.</h2>
    </div>          
</template>

<script>
export default {
    props: {
        title: String,
        documents: Array,
        loading: Boolean
    },
    methods: {
        changeState: function (document) {
            axios.patch(document.patch_href)
                .then(response => {
                    this.$emit('refresh');
                });            
        }
    }      
}
</script>

<style scoped>

</style>